export enum StakeholdersColumn {
  COMPANY = 'company',
  EMAIL = 'email',
  NAME = 'name',
  POPOVER = 'popover',
  SELECT = 'select',
  STATUS = 'status',
}

export const itemsToFetchMap = [5, 10, 15];

export const stakeholdersColumnTitle: Record<StakeholdersColumn, string> = {
  [StakeholdersColumn.SELECT]: '',
  [StakeholdersColumn.NAME]: 'Name',
  [StakeholdersColumn.EMAIL]: 'Email Address',
  [StakeholdersColumn.COMPANY]: 'Company',
  [StakeholdersColumn.STATUS]: 'Status',
  [StakeholdersColumn.POPOVER]: '',
};

export const stakeholdersColumnMap = Object.keys(stakeholdersColumnTitle);
